import { render, staticRenderFns } from "./rcc-checkbox.vue?vue&type=template&id=31004094&scoped=true&"
import script from "./rcc-checkbox.vue?vue&type=script&lang=js&"
export * from "./rcc-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./rcc-checkbox.vue?vue&type=style&index=0&id=31004094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31004094",
  null
  
)

export default component.exports